/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FROM_0_TO_9999_3_DECIMAL_REGEX } from '#utils/string/regex';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import Input from '#components/general/Input';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import { TIME_OFF_FIELDS, WASH_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const getTimeOffFields = ({ values, errors }) => {
  const getTimeOffValues = getSubStepValues(WASH_SUBSTEPS_IDS.TIME_OFF, values, errors);
  return [
    {
      key: 'titles',
      Component: AdelphiFieldsRow,
      fieldRowClassName: styles.timeOffAndChargingTitles,
      fields: [
        {
          key: 'dateAndTimeOff',
          Component: () => (
            <div className={styles.columnTitle}>{t(`${WASH_SUBSTEPS_IDS.TIME_OFF}:dateAndTimeOff`)}</div>
          )
        },
        {
          key: 'temperature',
          Component: () => (
            <div className={styles.columnTitle}>{t(`${WASH_SUBSTEPS_IDS.TIME_OFF}:temperature`)}</div>
          )
        },
        {
          key: 'hydrometerReading',
          Component: () => (
            <div className={styles.columnTitle}>{t(`${WASH_SUBSTEPS_IDS.TIME_OFF}:hydrometerReading`)}</div>
          )
        }
      ]
    },
    {
      key: 'firstRow',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getTimeOffValues(TIME_OFF_FIELDS.DATE_AND_TIME_OFF, false),
          Component: Input,
          type: 'datetime-local'
        },
        {
          ...getTimeOffValues(TIME_OFF_FIELDS.TEMPERATURE_TIME_OFF, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          measure: MEASURE_TYPES.TEMPERATURE
        },
        {
          ...getTimeOffValues(TIME_OFF_FIELDS.HYDROMETER_TIME_OFF, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX
        }
      ]
    }
  ];
};
